module.exports = __webpack_public_path__ + "register/img/paw-avatar.0909ba3c.png";